export default function createAvailableServiceTypesTranslations(translations) {
  if (!translations) {
    return {};
  }

  return Object.entries(translations)
    .reduce((acc, [key, localeTranslation]) => {
      acc[key] = {
        id: localeTranslation.id ?? '',
        locale: localeTranslation.locale ?? '',
        serviceTypeId: localeTranslation.service_type_id ?? '',
        name: localeTranslation?.name ?? '',
        description: localeTranslation.description ?? '',
        metaTitle: localeTranslation.meta_title ?? '',
      };

      return acc;
    }, {});
}
